import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { Dashboard } from "./Dashboard";
import DashboardQueryNode, {
  type DashboardQuery$variables,
} from "./__generated__/DashboardQuery.graphql";
import { filterFor } from "./DashboardTodoList";
import { appService } from "../../relay/environment";

const entryPoint: SimpleEntryPoint<typeof Dashboard> = {
  root: JSResource("Dashboard", () =>
    import("./Dashboard").then((module) => module.Dashboard),
  ),
  getPreloadProps() {
    const state = appService.getSnapshot();
    const employeeId =
      state.value === "authenticated" || state.value === "probablyAuthenticated"
        ? (state.context.employee?.id ?? null)
        : null;

    const variables: DashboardQuery$variables = filterFor(employeeId);

    return {
      queries: {
        query: {
          parameters: DashboardQueryNode,
          variables,
          options: {
            fetchPolicy: "store-and-network",
          },
        },
      },
    };
  },
};

export default entryPoint;
